import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { connect, Dispatch } from 'react-redux';
import { ICenterBillingRecord } from '@nkr/models/index';
import { OrganType } from '@nkr/enums/index';
import { IApplicationState, AppActionCreators, BillingActionCreators, IBillingCenterReportResponse } from '@nkr/store/index';
import { ColumnApi, GridApi, GridReadyEvent, ProcessCellForExportParams, ExcelExportParams, ColumnWidthCallbackParams } from 'ag-grid-community';
import { Button, ButtonToolbar, ToggleButtonGroup, ToggleButton, FormControl, Well, } from 'react-bootstrap';
import Grid from './grid';

interface IOwnProps {
    centerId: number,
    centerAlias: string
}

interface IStateProps {
    organType: OrganType
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getAccountsReceivableList: (organType: OrganType, receivableCenterId?: number, payableCenterId?: number) => Promise<IBillingCenterReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    list: ICenterBillingRecord[],
    radioFilter: number,
    invoiceStartDate: string,
    invoiceEndDate: string,
    centerId: number,
    filteredList: ICenterBillingRecord[],
    useFilter: boolean
}

interface IClearState {
    radioFilter: number,
    invoiceStartDate: string,
    invoiceEndDate: string
}

const initialClearState: IClearState = {
    radioFilter: 1,
    invoiceStartDate: moment().subtract(12, 'months').startOf('month').format('YYYY-MM-DD'),
    invoiceEndDate: moment().format('YYYY-MM-DD')
}

const initialState: IState = {
    ...initialClearState,
    list: [],
    centerId: 0,
    filteredList: [],
    useFilter: false
}

class AccountsReceivable extends React.Component<TProps, {}> {
    readonly state = initialState;

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        e.columnApi.applyColumnState({
            state: [
                { colId: 'centerHasLatePaymentsInLastYear', sort: 'asc' }
            ]
        });
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getAccountsReceivableList(this.props.organType, this.props.centerId, null)
                .then(response => {
                    if (response.data.success) {
                        let list = response.data.results;

                        var filteredList = list.filter(x => { return !x.isPaid && x.daysOutstanding >= 0 ? x : null });

                        this.setState({
                            list,
                            filteredList
                        }, () => {
                            this.props.hideLoading();
                        });
                    } else {
                        this.props.hideLoading();
                    }
                });
        });
    };

    handleRadioFilterChange = (radioType: number) => {
        this.setState({
            radioFilter: radioType
        }, () => {
            this.handleFilteredData();
        });
    }

    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    handleFilteredData = () => {
        //0=>all, 1=>pending
        var all = [0].includes(this.state.radioFilter);
        var pending = [1].includes(this.state.radioFilter);

        var filteredList = _.cloneDeep(this.state.list);

        if (all) {
            filteredList = filteredList.filter(x => { return x });

            filteredList = filteredList.filter(x => {

                const startDate = moment(this.state.invoiceStartDate);
                const endDate = moment(this.state.invoiceEndDate);
                const invoiceDate = moment(x.invoiceDate);

                return invoiceDate.isSameOrAfter(startDate, 'day') && invoiceDate.isSameOrBefore(endDate, 'day');
            });

        }
        else if (pending) {
            filteredList = filteredList.filter(x => { return !x.isPaid && x.daysOutstanding >= 0 ? x : null });
        }


        this.setState({
            useFilter: true,
            filteredList
        })
    }

    handleExport = () => {
        let keys = this.gridColumnApi.getAllColumns().map(x => x.getColId());

        let params: ExcelExportParams = {
            columnGroups: true,
            fileName: `accounts-receivable.xlsx`,
            columnKeys: keys,
            columnWidth: (params: ColumnWidthCallbackParams) => {
                let colDef = params.column.getColDef();
                return colDef.width;
            },
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();
                return params.value;
            },
        };

        this.gridApi.exportDataAsExcel(params);
    }

    handleClear = () => {
        this.setState(initialClearState);
    }

    render = () => {
        const filteredData = this.state.filteredList.length > 0 || this.state.useFilter ? this.state.filteredList : []
        const showDateFilter = [0].includes(this.state.radioFilter);

        return (
            <>
                <div className='container-fluid'>
                    <div style={{ padding: 10, borderWidth: '0px 1px 1px 1px', borderStyle: 'solid', borderColor: '#ddd', borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }}>

                        <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                            <div style={{ display: 'flex' }}>

                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }} >

                                    <div style={{ marginRight: 5 }}>Filters:</div>
                                    <ButtonToolbar>
                                        <ToggleButtonGroup type="radio" name="options" defaultValue={this.state.radioFilter}>
                                            <ToggleButton className="btn-bg" onClick={() => this.handleRadioFilterChange(1)} value={1}>
                                                Pending
                                            </ToggleButton>
                                            <ToggleButton className="btn-bg" onClick={() => this.handleRadioFilterChange(0)} value={0}>
                                                All
                                            </ToggleButton>

                                        </ToggleButtonGroup>
                                    </ButtonToolbar>
                                </div>

                                {showDateFilter && (<>
                                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '50px', marginRight: 10 }}>
                                        <div style={{ marginRight: 5 }}>Invoice Start Date:&nbsp;</div>
                                        <div>
                                            <FormControl
                                                type='date'
                                                name='invoiceStartDate'
                                                value={this.state.invoiceStartDate}
                                                onChange={this.handleDateChange}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 5 }}>
                                        <div style={{ marginRight: 5 }}>Invoice End Date:</div>
                                        <div>
                                            <FormControl
                                                type='date'
                                                name='invoiceEndDate'
                                                value={this.state.invoiceEndDate}
                                                onChange={this.handleDateChange}
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <Button bsStyle={'primary'} onClick={this.handleFilteredData}>Search</Button>
                                    </div>
                                </>
                                )}

                            </div>

                            <div style={{ display: 'flex', marginLeft: '50px' }}>
                                <Button bsStyle={'success'} onClick={this.handleExport}>Export to Excel</Button>
                            </div>
                        </Well>

                        <Grid data={filteredData} centerId={this.props.centerId} onGridReady={this.onGridReady} />
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        organType: appState.app.site.organType
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getAccountsReceivableList: (organType, receivableCenterId, payableCenterId) => {
            return dispatch(BillingActionCreators.getCenterBillingByList(organType, receivableCenterId, payableCenterId));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(AccountsReceivable);